import { render, staticRenderFns } from "./xsMxdetailCancleList.vue?vue&type=template&id=54477036&scoped=true"
import script from "./xsMxdetailCancleList.vue?vue&type=script&lang=js"
export * from "./xsMxdetailCancleList.vue?vue&type=script&lang=js"
import style0 from "./xsMxdetailCancleList.vue?vue&type=style&index=0&id=54477036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54477036",
  null
  
)

export default component.exports